import Home from './components/Home';
import Navbar from './components/Navbar';
import About from './components/About';
import { Box } from '@chakra-ui/react';
import Skills from './components/Skills';
import Projects from './components/Projects';
import Contact from './components/Contact';
import GitStats from './components/GitStats';
import "./App.css"

function App() {
  return (
    <Box bg={"#1a202c"}>
      <Navbar />
      <Home />
      <About />
      <Skills />
      <Projects />
      <GitStats />
      <Contact />
    </Box>
  );
}

export default App;
